import styled from "styled-components"

export const CreateFoodWrapper = styled.div<{ $background: string }>`
  --header-height: 44px;
  --cta-box-height: 72px;

  height: 100%;
  width: 100%;
  background: ${({ $background }) => $background};
`
